import React from "react";
import { Link } from "react-router-dom";
import abImg from "../../images/about-img.jpg";
import icon from "../../images/phone-call.svg";
import { useTranslation } from "react-i18next";

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  const { t } = useTranslation();

  return (
    <section className="about-section" style={{ padding: "170px 0" }}>
      <div className="container">
        <div className="wrap">
          <div className="left-img">
            <div className="about-1">
              <img src={abImg} alt="" />
            </div>
            {/* <div className="about-2">
              <img src={abImg2} alt="" />
            </div> */}
          </div>
          <div className="row">
            <div className="col-lg-6 offset-lg-6">
              <div className="content">
                <div className="section-title">
                  <h2>{t("aboutUs")}</h2>
                  <h3 className="title">{t("welcome")}</h3>
                  <p>{t("aboutUsText")}</p>
                </div>
                <div className="about-bottom" dir="ltr">
                  <Link
                    onClick={ClickHandler}
                    to={"/shop"}
                    className="theme-btn"
                  >
                    {t("discoverMore")}
                  </Link>

                  <div className="call">
                    <div className="icon">
                      <img src={icon} alt="" />
                    </div>
                    <div className="text">
                      <span>{t("callUs")}</span>
                      <a href="tel:+(966) 111 2222">+(966) 111 2222</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
